var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 2.8335H2.83341C2.05212 2.8335 1.41675 3.46887 1.41675 4.25016V12.7502C1.41675 13.5315 2.05212 14.1668 2.83341 14.1668H14.1667C14.948 14.1668 15.5834 13.5315 15.5834 12.7502V4.25016C15.5834 3.46887 14.948 2.8335 14.1667 2.8335ZM14.1667 4.25016V4.61212L8.50008 9.02008L2.83341 4.61283V4.25016H14.1667ZM2.83341 12.7502V6.40633L8.06516 10.4757C8.1892 10.5731 8.34236 10.6261 8.50008 10.6261C8.65781 10.6261 8.81096 10.5731 8.935 10.4757L14.1667 6.40633L14.1682 12.7502H2.83341Z",
    fill: "#007DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8a39d97f923b35e6f401788a9405dd41.svg";
export { ForwardRef as ReactComponent };